<template>
  <div>
    <ed-funcionario :intFuncionarioId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdFuncionario from '@/components/cadastro/funcionario/editar'

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdFuncionario },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "cadastro.empresa.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>